import { formatDateTime } from './dates';

// Why a ticket is assigned (28/10), shown on hover in the ticket table.
// `ticket.assignment_reason` is the backend's view:
//   { source: 'assignment' | 'external' | 'escalation' | 'unknown',
//     text, by: 'ai' | 'human' | 'system', by_name, assignee_name, at,
//     escalation?: { text, at } }
// `source` other than 'assignment' = an assignment made before the reason was
// recorded (or mirrored from the external system): only what is known.

const NOT_ASSIGNED = 'Not Assigned';

export const assigneeName = (ticket) => {
  const reason = ticket?.assignment_reason || {};
  const fallback = ticket?.employee_name && ticket.employee_name !== NOT_ASSIGNED ? ticket.employee_name : null;
  return reason.assignee_name || fallback || null;
};

export const assignmentTooltipText = (t, ticket) => {
  const reason = ticket?.assignment_reason;
  if (!reason) return '';
  const name = assigneeName(ticket) || t('assignmentReason.someone', 'a team member');
  let head;
  if (reason.source === 'assignment') {
    let by;
    if (reason.by === 'ai') by = t('assignmentReason.byAi', 'the AI');
    else if (reason.by === 'human') by = reason.by_name || t('assignmentReason.byTeamMember', 'a team member');
    else by = t('assignmentReason.bySystem', 'the system');
    head = reason.at
      ? t('assignmentReason.assignedByOn', 'Assigned to {{name}} by {{by}} on {{date}}',
        { name, by, date: formatDateTime(reason.at) })
      : t('assignmentReason.assignedBy', 'Assigned to {{name}} by {{by}}', { name, by });
  } else if (reason.source === 'external') {
    head = t('assignmentReason.assignedExternal', 'Assigned to {{name}} in the external system', { name });
  } else {
    head = t('assignmentReason.assignedTo', 'Assigned to {{name}}', { name });
  }
  const lines = [reason.text ? `${head} — ${reason.text}` : head];
  if (reason.escalation && reason.escalation.text) {
    lines.push(reason.escalation.at
      ? t('assignmentReason.escalationOn', 'Last hand-over by the AI on {{date}} — {{text}}',
        { date: formatDateTime(reason.escalation.at), text: reason.escalation.text })
      : t('assignmentReason.escalation', 'Last hand-over by the AI — {{text}}', { text: reason.escalation.text }));
  }
  return lines.join('\n');
};
